<page-toolbar [title]="'pages.content-pool' | translate" [pageActions]="pageActions"></page-toolbar>

<page-content>
  <data-table *ngIf="params && !isLoading" [dataProvider]="dcService" [dataProviderParams]="params" [columns]="columns"
              (edit)="editEntry($event)" [newHeader]="true" [headerButtons]="headerButtons" [noCard]="true"
              [title]="dynamicContentTitles[type]" (remove)="removeEntry($event)"></data-table>
</page-content>
